import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Button as BaseButton } from '@leroy-merlin-br/backyard-react-ui'

const wrapperStyles = ({ theme }) => css`
  label: wrapper;

  position: relative;

  text-align: center;
  background: ${theme.colors.white};

  width: 638px;
  height: 305px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: auto;
`

const modalCloseStyles = ({ theme }) => css`
  label: modal__button-close;

  position: absolute;

  top: ${theme.spacings.mega};
  right: ${theme.spacings.mega};

  color: ${theme.colors.n800};
  cursor: pointer;
`

const titleStyles = ({ theme }) => css`
  label: modal__title;

  display: block;

  color: ${theme.colors.n800};
  font-size: ${theme.typography.text.giga.fontSize};
  font-weight: 600;

  margin-bottom: 10px;
`

const descriptionStyles = ({ theme }) => css`
  label: modal__description;

  display: block;

  color: ${theme.colors.n500};
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  font-weight: 400;
  line-height: 1.5;

  width: 60%;
`

const buttonStyles = ({ theme }) => css`
  font-size: ${theme.typography.subHeadings.mega.fontSize};

  margin-top: 35px;
  max-width: 205px;
`

export const Wrapper = styled('div')(wrapperStyles)
export const ModalClose = styled('div')(modalCloseStyles)
export const Title = styled('span')(titleStyles)
export const Description = styled('span')(descriptionStyles)
export const Button = styled(BaseButton)(buttonStyles)
